import { useElementsEditForm, UseElementsEditFormFormArgs } from '../../../hooks';
import { PersonalPropertyItemFormValues } from '../types';

export const useEditPersonalPropertyItemForm = (args: UseElementsEditFormFormArgs<PersonalPropertyItemFormValues>) =>
  useElementsEditForm<PersonalPropertyItemFormValues>(args);
